<search-dialog-page [model]="model" (onAction)="action($event)">
  <div class="container-fluid">
    <ep-row class="col-12">
      <form
        (ngSubmit)="dsCollection.refresh(); model.dirty = false"
        (keypress)="model.dirty = true"
        style="width: 100%; margin-bottom: 0px; margin-top: 0px"
      >
        <ep-row>
          <div class="col-12 col-md-6 col-lg-4">
            <div class="unity-form-group" style="display: inline-block">
              <label for="Entity_Name">Entity Name</label>
              <input
                myFocus
                type="text"
                name="Entity_Name"
                [(ngModel)]="dsCollection.criteria.Entity_Name"
                ngControl="Entity_Name"
                (valueChange)="model.dirty = true"
              />
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-4">
            <div class="unity-form-group" style="display: inline-block">
              <label for="Entity_Quick_Search">Quick Search</label>
              <input
                type="text"
                name="Entity_Quick_Search"
                [(ngModel)]="dsCollection.criteria.Entity_Quick_Search"
                ngControl="Entity_Quick_Search"
              />
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-4" *ngIf="entityModel.showRoleType">
            <div class="unity-form-group select" style="display: inline-block">
              <label for="Role_Type">Role</label>
              <ep-dropdown
                class="unity-form-row w-100"
                name="Role_Type"
                [codeValues]="entityModel.roleTypeDropdownCodes"
                [nullValue]="{ Code: entityModel.roleTypeNullValue, Code_Desc: 'All' }"
                [(ngModel)]="dsCollection.criteria.Role_Type"
                (ngModelChange)="model.dirty = true"
              ></ep-dropdown>
            </div>
          </div>

          <div [class]="entityModel.showRoleType ? 'col-12' : 'col-12 col-lg-4'">
            <unity-button-old
              class="pull-right margin-l-5"
              style="margin-top: 16px"
              type="submit"
              classes="primary"
              [loading]="dsCollection && dsCollection.status == 'Loading'"
              [dirty]="model.dirty"
            >
              Search
            </unity-button-old>
            <unity-button-old
              class="pull-right margin-l-5"
              type="button"
              (click)="reset()"
              classes="secondary"
              style="margin-top: 16px"
            >
              Reset
            </unity-button-old>
          </div>
        </ep-row>
      </form>
    </ep-row>

    <ep-row>
      <div
        class="col-12"
        style="margin: 5px 5px 5px 5px; border-top: solid 1px; padding-top: 5px; border-top-color: #e5e3e3"
      >
        <ep-filter-input
          #entityFilter
          style="margin-bottom: 5px"
          [filter]="{
            keys: {
              Entity_Name: 'Name',
              Phone_Num: 'Phone',
              Email_Address: 'Email',
              Address_Line_1: 'Address',
              City: 'City',
              Zip: 'Zip'
            },
            maxDepth: true
          }"
        ></ep-filter-input>

        <ep-max-row-warning [datasource]="dsCollection"></ep-max-row-warning>

        <div
          class="table-responsive"
          style="
            max-height: 400px;
            min-height: 400px;
            overflow-y: scroll;
            overflow-x: hidden;
            margin-top: 5px;
            border: 1px solid silver;
          "
        >
          <table class="table table-select table-fixed-header">
            <tr>
              <th style="z-index: 1">Entity Name</th>
              <th *ngIf="entityModel.affiliate" style="z-index: 1">Function</th>
              <th *ngIf="entityModel.affiliate" style="z-index: 1">Department</th>
            </tr>
            <tr
              *ngFor="
                let entity of dsCollection.objectNodes | epFilter : entityFilter.filter : entityFilter.filter.filterText
              "
              (click)="app.getSelectedText() && select(entity)"
            >
              <td>
                <div class="col-sm-12 col-12">
                  <div style="display: inline-block">
                    <span>{{ entity.Entity_Index_Name }}</span>
                    <span *ngIf="entity.Organization && entity.Organization.Entity_Name">
                      of {{ entity.Organization.Entity_Name }}
                    </span>
                  </div>

                  <div style="width: 60px; display: inline-block" class="pull-md-left">
                    <span
                      *ngFor="let role of entity.Roles?.Role"
                      [style.color]="
                        role.Disabled_Ind == 'Y'
                          ? 'red'
                          : role.Preferred_Ind == 'Y'
                          ? 'green'
                          : role.Prospect_Ind == 'Y'
                          ? '#ff6a00'
                          : ''
                      "
                      (click)="checkboxClicked(role)"
                    >
                      <span
                        *ngIf="['FC', 'PR', 'TA', 'TP'].indexOf(role.Role_Type) === -1"
                        class="fa-stack"
                        [ngbTooltip]="
                          (role['Disabled_Ind'] == 'Y' ? 'Disabled ' : '') +
                          (role['Prospect_Ind'] == 'Y' ? 'Prospective ' : '') +
                          (role.Preferred_Ind == 'Y' ? 'Preferred ' : '') +
                          role.Desc
                        "
                      >
                        <svg
                          *ngIf="getObjectIcon(role.Role_Type).includes('unity-icon')"
                          [class]="'unity-icon unity-icon-lg ' + getObjectIcon(role.Role_Type)"
                        >
                          <use attr.xlink:href="#{{ getObjectIcon(role.Role_Type) }}"></use>
                        </svg>
                        <ng-container *ngIf="!getObjectIcon(role.Role_Type).includes('unity-icon')">
                          <i [class]="'fa fa-stack-1x  unity-icon unity-icon-lg ' + getObjectIcon(role.Role_Type)"></i>
                        </ng-container>
                      </span>
                      <span
                        *ngIf="['FC', 'PR', 'TA', 'TP'].indexOf(role.Role_Type) !== -1"
                        style="display: inline-block; margin: 2px"
                        [ngbTooltip]="
                          (role['Disabled_Ind'] == 'Y' ? 'Disabled ' : '') +
                          (role['Prospect_Ind'] == 'Y' ? 'Prospective ' : '') +
                          (role.Preferred_Ind == 'Y' ? 'Preferred ' : '') +
                          role.Desc
                        "
                      >
                        <div *ngIf="role.Role_Type === 'FC'" data-initials="FC"></div>
                        <div *ngIf="role.Role_Type === 'PR'" data-initials="PR"></div>
                        <div *ngIf="role.Role_Type === 'TA'" data-initials="TA"></div>
                        <div *ngIf="role.Role_Type === 'TP'" data-initials="TP"></div>
                      </span>
                    </span>

                    <span
                      *ngIf="entity.Organization && entity.Organization.Entity_Name"
                      class="fa-stack"
                      ngbTooltip="Affiliate"
                    >
                      <i class="fa fa-stack-1x fa-ep-entity-affiliate unity-icon unity-icon-lg"></i>
                    </span>
                  </div>

                  <span class="margin-l-5" *ngFor="let role of entity.Roles?.Role">
                    <svg
                      *ngIf="role['Disabled_Ind'] == 'Y'"
                      class="unity-icon unity-icon-warning me-1"
                      style="fill: red"
                      [ngbTooltip]="'Disabled ' + role.Desc"
                    >
                      <use xlink:href="#unity-icon-warning"></use>
                    </svg>
                    <i
                      *ngIf="role['Prospect_Ind'] == 'Y'"
                      style="color: #ff6a00"
                      class="fa fa-ep-prospect me-1"
                      [ngbTooltip]="'Prospective ' + role.Desc"
                    ></i>
                    <i
                      *ngIf="role['Preferred_Ind'] == 'Y'"
                      style="color: green"
                      class="fa fa-ep-preferred"
                      [ngbTooltip]="'Preferred ' + role.Desc"
                    ></i>
                  </span>
                </div>
              </td>

              <td *ngIf="entityModel.affiliate">{{ entity?.Function?.Desc }}</td>
              <td *ngIf="entityModel.affiliate">{{ entity?.Department?.Desc }}</td>
            </tr>

            <tr
              class="col-12"
              *ngIf="
                !(dsCollection.objectNodes && dsCollection.objectNodes.length > 0) && dsCollection.status == 'Ready'
              "
            >
              <td>
                <span style="text-align: center"><i>No Entities</i></span>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </ep-row>
  </div>
</search-dialog-page>
